export function normalizeDischargeDate(raw: string): string {
  const dateOnly = raw.split('T')[0]
  const isValidDate = dateOnly.length > 0 && !isNaN(new Date(dateOnly).getTime())
  return isValidDate ? dateOnly : new Date().toISOString().split('T')[0]
}
